export default {
  props: {
    type: {
      type: String,
      default: "sectionBox",
    },
    formContent: Object,
  },
  data() {
    return {
      id: this.$options.name,
    };
  },
  watch: {
    focus() {},
    formData() {},
    optionsData() {},
  },
};
